import React from "react";
import { traditionHref } from "./lib/selection";

// A segmented control in the header, not two stacked cards with a family
// subhead each. `family` stays in the data — it earns its place at four
// traditions, not two — so the grouping shows only where a family has more
// than one member.
const FAMILY_LABELS = { hermetic: "Hermetic", jewish: "Jewish" };

export default function TraditionSwitch({ traditions, current, selected }) {
  // A switch with one option is noise.
  if (!traditions || traditions.length < 2) return null;

  const counts = traditions.reduce((acc, t) => {
    acc[t.family] = (acc[t.family] || 0) + 1;
    return acc;
  }, {});
  // Per FAMILY, not globally. Showing it for every option meant the Hermetic
  // one read "HERMETIC / Hermetic Qabalah", which says it twice and tells you
  // nothing; "Jewish / Gra Arrangement" earns its line.

  return (
    <nav className="switch" aria-label="Tradition">
      <div className="segmented">
        {traditions.map((tradition) => {
          const active = tradition.slug === current.slug;
          return (
            <a
              key={tradition.slug}
              className={active ? "segmented__item segmented__item--on" : "segmented__item"}
              href={traditionHref(tradition, selected)}
              aria-current={active ? "page" : undefined}
              title={tradition.shortDescription}
              data-testid={`switch-${tradition.slug}`}
            >
              {counts[tradition.family] > 1 && (
                <span className="segmented__family">
                  {FAMILY_LABELS[tradition.family] || tradition.family}
                </span>
              )}
              {tradition.name}
            </a>
          );
        })}
      </div>
    </nav>
  );
}
